/* global Cookies */

window.Reverb = window.Reverb || {};
Reverb.UserActivity = (function () {
  const cookieName = 'reverb_page_views';
  let currentPageViews = null;
  const expiresInDays = 1000;

  function init() {
    currentPageViews = parseInt(Cookies.get(cookieName));
    if (!currentPageViews) { currentPageViews = 1; }

    Cookies.set(cookieName, currentPageViews + 1, { path: '/', expires: expiresInDays });
  }

  function pageViews() {
    return currentPageViews;
  }

  return {
    init,
    pageViews,
  };
}());


$(() => {
  Reverb.UserActivity.init();
});



// WEBPACK FOOTER //
// ./src/components/legacy/user_activity.js